import {
  ILegalEntityLicenceVaryFormValues,
  ILegalEntityLicenceRenewFormValues,
} from 'models/legalEntity';

export const sanitizeVaryFormData = (
  data: ILegalEntityLicenceVaryFormValues,
): ILegalEntityLicenceVaryFormValues => {
  const sanitized = { ...data };

  delete (sanitized as any).documents;
  return sanitized;
};

export const sanitizeRenewFormData = (
  data: ILegalEntityLicenceRenewFormValues,
): ILegalEntityLicenceRenewFormValues => {
  const sanitized = { ...data };

  if ((sanitized as any).document && (sanitized as any).document.documents) {
    (sanitized as any).documents = (sanitized as any).document.documents;
  }

  delete (sanitized as any).document;
  delete (sanitized.general as any).priceUniqueId;

  return sanitized;
};
